var ln = Object.defineProperty;
var dn = (o, t, n) => t in o ? ln(o, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[t] = n;
var he = (o, t, n) => (dn(o, typeof t != "symbol" ? t + "" : t, n), n);
import rt, { createContext as zt, useReducer as fn, useState as A, useRef as ee, useEffect as M, useMemo as He, useContext as vt, useCallback as Qt, forwardRef as Xt, useImperativeHandle as vn, useLayoutEffect as hn } from "react";
import $e from "@emotion/styled";
import { useTranslation as ze } from "react-i18next";
import { Howl as Ot } from "howler";
import { Button as Te, Heading as jt, Paragraph as gn, LoadingSpinner as mn, Icon as yn } from "@cue/atoms";
import Sn from "react-perfect-scrollbar";
import { BrowserUtil as Nt, AnalyticsTransformer as Jt } from "@cue/utility";
import pn from "classnames";
import { useFullscreen as Zt, useHash as bn, useSound as En } from "@cue/hooks";
import { v4 as ft } from "uuid";
import { LanguageSelector as Cn } from "@cue/molecules";
import _n, { unstable_batchedUpdates as wn } from "react-dom";
var kt = { exports: {} }, lt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ut;
function Rn() {
  if (Ut)
    return lt;
  Ut = 1;
  var o = rt, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(E, f, u) {
    var c, C = {}, T = null, I = null;
    u !== void 0 && (T = "" + u), f.key !== void 0 && (T = "" + f.key), f.ref !== void 0 && (I = f.ref);
    for (c in f)
      r.call(f, c) && !i.hasOwnProperty(c) && (C[c] = f[c]);
    if (E && E.defaultProps)
      for (c in f = E.defaultProps, f)
        C[c] === void 0 && (C[c] = f[c]);
    return { $$typeof: t, type: E, key: T, ref: I, props: C, _owner: s.current };
  }
  return lt.Fragment = n, lt.jsx = a, lt.jsxs = a, lt;
}
var dt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kt;
function Tn() {
  return Kt || (Kt = 1, { USE_LOCATION_HASH: !0, SHOW_SHOWROOM_NAVIGATION_MENU: !0, APP_VERSION: '"3.6.2"' }.NODE_ENV !== "production" && function() {
    var o = rt, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), E = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), C = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), I = Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function k(e) {
      if (e === null || typeof e != "object")
        return null;
      var l = w && e[w] || e[N];
      return typeof l == "function" ? l : null;
    }
    var x = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function d(e) {
      {
        for (var l = arguments.length, y = new Array(l > 1 ? l - 1 : 0), P = 1; P < l; P++)
          y[P - 1] = arguments[P];
        _("error", e, y);
      }
    }
    function _(e, l, y) {
      {
        var P = x.ReactDebugCurrentFrame, j = P.getStackAddendum();
        j !== "" && (l += "%s", y = y.concat([j]));
        var K = y.map(function(B) {
          return String(B);
        });
        K.unshift("Warning: " + l), Function.prototype.apply.call(console[e], console, K);
      }
    }
    var h = !1, g = !1, O = !1, F = !1, v = !1, p;
    p = Symbol.for("react.module.reference");
    function V(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === r || e === i || v || e === s || e === u || e === c || F || e === I || h || g || O || typeof e == "object" && e !== null && (e.$$typeof === T || e.$$typeof === C || e.$$typeof === a || e.$$typeof === E || e.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === p || e.getModuleId !== void 0));
    }
    function L(e, l, y) {
      var P = e.displayName;
      if (P)
        return P;
      var j = l.displayName || l.name || "";
      return j !== "" ? y + "(" + j + ")" : y;
    }
    function W(e) {
      return e.displayName || "Context";
    }
    function b(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && d("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case E:
            var l = e;
            return W(l) + ".Consumer";
          case a:
            var y = e;
            return W(y._context) + ".Provider";
          case f:
            return L(e, e.render, "ForwardRef");
          case C:
            var P = e.displayName || null;
            return P !== null ? P : b(e.type) || "Memo";
          case T: {
            var j = e, K = j._payload, B = j._init;
            try {
              return b(B(K));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var D = Object.assign, G = 0, ae, te, Q, Ce, Se, ge, _e;
    function Ae() {
    }
    Ae.__reactDisabledLog = !0;
    function Ie() {
      {
        if (G === 0) {
          ae = console.log, te = console.info, Q = console.warn, Ce = console.error, Se = console.group, ge = console.groupCollapsed, _e = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        G++;
      }
    }
    function it() {
      {
        if (G--, G === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: D({}, e, {
              value: ae
            }),
            info: D({}, e, {
              value: te
            }),
            warn: D({}, e, {
              value: Q
            }),
            error: D({}, e, {
              value: Ce
            }),
            group: D({}, e, {
              value: Se
            }),
            groupCollapsed: D({}, e, {
              value: ge
            }),
            groupEnd: D({}, e, {
              value: _e
            })
          });
        }
        G < 0 && d("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ue = x.ReactCurrentDispatcher, pe;
    function Le(e, l, y) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (j) {
            var P = j.stack.trim().match(/\n( *(at )?)/);
            pe = P && P[1] || "";
          }
        return `
` + pe + e;
      }
    }
    var Ke = !1, Me;
    {
      var re = typeof WeakMap == "function" ? WeakMap : Map;
      Me = new re();
    }
    function q(e, l) {
      if (!e || Ke)
        return "";
      {
        var y = Me.get(e);
        if (y !== void 0)
          return y;
      }
      var P;
      Ke = !0;
      var j = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var K;
      K = Ue.current, Ue.current = null, Ie();
      try {
        if (l) {
          var B = function() {
            throw Error();
          };
          if (Object.defineProperty(B.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(B, []);
            } catch (Ve) {
              P = Ve;
            }
            Reflect.construct(e, [], B);
          } else {
            try {
              B.call();
            } catch (Ve) {
              P = Ve;
            }
            e.call(B.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ve) {
            P = Ve;
          }
          e();
        }
      } catch (Ve) {
        if (Ve && P && typeof Ve.stack == "string") {
          for (var $ = Ve.stack.split(`
`), le = P.stack.split(`
`), z = $.length - 1, J = le.length - 1; z >= 1 && J >= 0 && $[z] !== le[J]; )
            J--;
          for (; z >= 1 && J >= 0; z--, J--)
            if ($[z] !== le[J]) {
              if (z !== 1 || J !== 1)
                do
                  if (z--, J--, J < 0 || $[z] !== le[J]) {
                    var Ee = `
` + $[z].replace(" at new ", " at ");
                    return e.displayName && Ee.includes("<anonymous>") && (Ee = Ee.replace("<anonymous>", e.displayName)), typeof e == "function" && Me.set(e, Ee), Ee;
                  }
                while (z >= 1 && J >= 0);
              break;
            }
        }
      } finally {
        Ke = !1, Ue.current = K, it(), Error.prepareStackTrace = j;
      }
      var Ze = e ? e.displayName || e.name : "", Ht = Ze ? Le(Ze) : "";
      return typeof e == "function" && Me.set(e, Ht), Ht;
    }
    function We(e, l, y) {
      return q(e, !1);
    }
    function Ge(e) {
      var l = e.prototype;
      return !!(l && l.isReactComponent);
    }
    function we(e, l, y) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return q(e, Ge(e));
      if (typeof e == "string")
        return Le(e);
      switch (e) {
        case u:
          return Le("Suspense");
        case c:
          return Le("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case f:
            return We(e.render);
          case C:
            return we(e.type, l, y);
          case T: {
            var P = e, j = P._payload, K = P._init;
            try {
              return we(K(j), l, y);
            } catch {
            }
          }
        }
      return "";
    }
    var ne = Object.prototype.hasOwnProperty, m = {}, U = x.ReactDebugCurrentFrame;
    function H(e) {
      if (e) {
        var l = e._owner, y = we(e.type, e._source, l ? l.type : null);
        U.setExtraStackFrame(y);
      } else
        U.setExtraStackFrame(null);
    }
    function X(e, l, y, P, j) {
      {
        var K = Function.call.bind(ne);
        for (var B in e)
          if (K(e, B)) {
            var $ = void 0;
            try {
              if (typeof e[B] != "function") {
                var le = Error((P || "React class") + ": " + y + " type `" + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[B] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw le.name = "Invariant Violation", le;
              }
              $ = e[B](l, B, P, y, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (z) {
              $ = z;
            }
            $ && !($ instanceof Error) && (H(j), d("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", P || "React class", y, B, typeof $), H(null)), $ instanceof Error && !($.message in m) && (m[$.message] = !0, H(j), d("Failed %s type: %s", y, $.message), H(null));
          }
      }
    }
    var me = Array.isArray;
    function Y(e) {
      return me(e);
    }
    function be(e) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, y = l && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return y;
      }
    }
    function Fe(e) {
      try {
        return fe(e), !1;
      } catch {
        return !0;
      }
    }
    function fe(e) {
      return "" + e;
    }
    function ie(e) {
      if (Fe(e))
        return d("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", be(e)), fe(e);
    }
    var ve = x.ReactCurrentOwner, Qe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ye, xe, Xe;
    Xe = {};
    function gt(e) {
      if (ne.call(e, "ref")) {
        var l = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function wt(e) {
      if (ne.call(e, "key")) {
        var l = Object.getOwnPropertyDescriptor(e, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Rt(e, l) {
      if (typeof e.ref == "string" && ve.current && l && ve.current.stateNode !== l) {
        var y = b(ve.current.type);
        Xe[y] || (d('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', b(ve.current.type), e.ref), Xe[y] = !0);
      }
    }
    function at(e, l) {
      {
        var y = function() {
          Ye || (Ye = !0, d("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        y.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: y,
          configurable: !0
        });
      }
    }
    function Tt(e, l) {
      {
        var y = function() {
          xe || (xe = !0, d("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        y.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: y,
          configurable: !0
        });
      }
    }
    var mt = function(e, l, y, P, j, K, B) {
      var $ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: l,
        ref: y,
        props: B,
        // Record the component responsible for creating this element.
        _owner: K
      };
      return $._store = {}, Object.defineProperty($._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty($, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.defineProperty($, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: j
      }), Object.freeze && (Object.freeze($.props), Object.freeze($)), $;
    };
    function yt(e, l, y, P, j) {
      {
        var K, B = {}, $ = null, le = null;
        y !== void 0 && (ie(y), $ = "" + y), wt(l) && (ie(l.key), $ = "" + l.key), gt(l) && (le = l.ref, Rt(l, j));
        for (K in l)
          ne.call(l, K) && !Qe.hasOwnProperty(K) && (B[K] = l[K]);
        if (e && e.defaultProps) {
          var z = e.defaultProps;
          for (K in z)
            B[K] === void 0 && (B[K] = z[K]);
        }
        if ($ || le) {
          var J = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          $ && at(B, J), le && Tt(B, J);
        }
        return mt(e, $, le, j, P, ve.current, B);
      }
    }
    var st = x.ReactCurrentOwner, ct = x.ReactDebugCurrentFrame;
    function Be(e) {
      if (e) {
        var l = e._owner, y = we(e.type, e._source, l ? l.type : null);
        ct.setExtraStackFrame(y);
      } else
        ct.setExtraStackFrame(null);
    }
    var Je;
    Je = !1;
    function ut(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function R() {
      {
        if (st.current) {
          var e = b(st.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Ne(e) {
      {
        if (e !== void 0) {
          var l = e.fileName.replace(/^.*[\\\/]/, ""), y = e.lineNumber;
          return `

Check your code at ` + l + ":" + y + ".";
        }
        return "";
      }
    }
    var ye = {};
    function ue(e) {
      {
        var l = R();
        if (!l) {
          var y = typeof e == "string" ? e : e.displayName || e.name;
          y && (l = `

Check the top-level render call using <` + y + ">.");
        }
        return l;
      }
    }
    function Re(e, l) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var y = ue(l);
        if (ye[y])
          return;
        ye[y] = !0;
        var P = "";
        e && e._owner && e._owner !== st.current && (P = " It was passed a child from " + b(e._owner.type) + "."), Be(e), d('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', y, P), Be(null);
      }
    }
    function De(e, l) {
      {
        if (typeof e != "object")
          return;
        if (Y(e))
          for (var y = 0; y < e.length; y++) {
            var P = e[y];
            ut(P) && Re(P, l);
          }
        else if (ut(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var j = k(e);
          if (typeof j == "function" && j !== e.entries)
            for (var K = j.call(e), B; !(B = K.next()).done; )
              ut(B.value) && Re(B.value, l);
        }
      }
    }
    function ke(e) {
      {
        var l = e.type;
        if (l == null || typeof l == "string")
          return;
        var y;
        if (typeof l == "function")
          y = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === C))
          y = l.propTypes;
        else
          return;
        if (y) {
          var P = b(l);
          X(y, e.props, "prop", P, e);
        } else if (l.PropTypes !== void 0 && !Je) {
          Je = !0;
          var j = b(l);
          d("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", j || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && d("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function qe(e) {
      {
        for (var l = Object.keys(e.props), y = 0; y < l.length; y++) {
          var P = l[y];
          if (P !== "children" && P !== "key") {
            Be(e), d("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", P), Be(null);
            break;
          }
        }
        e.ref !== null && (Be(e), d("Invalid attribute `ref` supplied to `React.Fragment`."), Be(null));
      }
    }
    function Bt(e, l, y, P, j, K) {
      {
        var B = V(e);
        if (!B) {
          var $ = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && ($ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var le = Ne(j);
          le ? $ += le : $ += R();
          var z;
          e === null ? z = "null" : Y(e) ? z = "array" : e !== void 0 && e.$$typeof === t ? (z = "<" + (b(e.type) || "Unknown") + " />", $ = " Did you accidentally export a JSX literal instead of a component?") : z = typeof e, d("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", z, $);
        }
        var J = yt(e, l, y, j, K);
        if (J == null)
          return J;
        if (B) {
          var Ee = l.children;
          if (Ee !== void 0)
            if (P)
              if (Y(Ee)) {
                for (var Ze = 0; Ze < Ee.length; Ze++)
                  De(Ee[Ze], e);
                Object.freeze && Object.freeze(Ee);
              } else
                d("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              De(Ee, e);
        }
        return e === r ? qe(J) : ke(J), J;
      }
    }
    function an(e, l, y) {
      return Bt(e, l, y, !0);
    }
    function sn(e, l, y) {
      return Bt(e, l, y, !1);
    }
    var cn = sn, un = an;
    dt.Fragment = r, dt.jsx = cn, dt.jsxs = un;
  }()), dt;
}
({ USE_LOCATION_HASH: !0, SHOW_SHOWROOM_NAVIGATION_MENU: !0, APP_VERSION: '"3.6.2"' }).NODE_ENV === "production" ? kt.exports = Rn() : kt.exports = Tn();
var Ft = kt.exports;
const Pe = Ft.Fragment, S = Ft.jsx, ce = Ft.jsxs;
var de;
(function(o) {
  o.ChangeScene = "CHANGE_SCENE", o.SceneChanged = "SCENE_CHANGED", o.SaveCurrentScene = "SAVE_CURRENT_SCENE", o.ToggleInfoBox = "TOGGLE_INFO_BOX", o.ToggleTransition = "TOGGLE_TRANSITION";
})(de || (de = {}));
const en = {
  changeDisabled: !1,
  inTransition: !1,
  infoBoxOpen: !1
}, ht = zt({
  state: en,
  dispatch: () => null
}), On = (o, t) => {
  switch (t.type) {
    case de.ChangeScene:
      return {
        ...o,
        inTransition: !0,
        changeSceneToKey: t.changeSceneToKey ?? o.changeSceneToKey
      };
    case de.SceneChanged:
      return {
        ...o,
        inTransition: !1
      };
    case de.SaveCurrentScene:
      return {
        ...o,
        currentScene: t.currentScene
      };
    case de.ToggleInfoBox:
      return {
        ...o,
        infoBoxOpen: (t == null ? void 0 : t.infoBoxOpen) || !1
      };
    case de.ToggleTransition:
      return console.log("VideoPlatformStateAction.ToggleTransition", t), {
        ...o,
        inTransition: (t == null ? void 0 : t.inTransition) || !1
      };
    default:
      return o;
  }
}, Eo = (o) => {
  const [t, n] = fn(On, en);
  return S(ht.Provider, { value: { state: t, dispatch: n }, children: o.children });
}, In = ({ soundOn: o, background: t, backgroundTranslations: n, transition: r, dimSound: s, language: i = "en" }) => {
  const [a, E] = A(t), [f, u] = A(r), c = ee(), C = ee(), T = ee(), I = 0.5, w = 0.1, N = (d) => {
    d && (c.current && c.current.stop(), c.current = new Ot({
      src: d,
      autoplay: !0,
      volume: 0.5,
      loop: t == null ? void 0 : t.loop,
      mute: !o
    }));
  }, k = (d) => {
    d && (C.current && C.current.stop(), C.current = new Ot({
      src: d,
      autoplay: !0,
      volume: 0.35,
      loop: !1,
      mute: !o
    }), c.current && c.current.volume(w), C.current.on("end", function() {
      c.current && c.current.volume(I);
    }));
  }, x = (d) => {
    var h;
    T.current && T.current.stop();
    const _ = ((h = d == null ? void 0 : d.formats) == null ? void 0 : h.map(({ src: g }) => g)) || null;
    if (T.current && T.current.stop(), !_) {
      c.current && c.current.volume(I);
      return;
    }
    c.current && c.current.volume(w), T.current = new Ot({
      src: _,
      autoplay: !0,
      volume: 0.5,
      loop: !1,
      mute: !o
    }), T.current.on("end", function() {
      c.current && c.current.volume(I);
    });
  };
  return M(() => {
    var d, _, h;
    o && (k(((_ = (d = n == null ? void 0 : n[i]) == null ? void 0 : d.formats) == null ? void 0 : _.map(({ src: g }) => g)) || null), N(((h = a == null ? void 0 : a.formats) == null ? void 0 : h.map(({ src: g }) => g)) || null));
  }, [a, o, i]), M(() => {
    u(r);
  }, [r]), M(() => {
    x(f);
  }, [f]), M(() => {
    var d, _, h;
    t != null && t.formats && ((d = t == null ? void 0 : t.formats) == null ? void 0 : d[0].src) !== (a == null ? void 0 : a.formats[0].src) && E(t), C.current && C.current.stop(), k(((h = (_ = n == null ? void 0 : n[i]) == null ? void 0 : _.formats) == null ? void 0 : h.map(({ src: g }) => g)) || null);
  }, [t]), M(() => {
    var d, _, h;
    o && (k(((_ = (d = n == null ? void 0 : n[i]) == null ? void 0 : d.formats) == null ? void 0 : _.map(({ src: g }) => g)) || null), N(((h = a == null ? void 0 : a.formats) == null ? void 0 : h.map(({ src: g }) => g)) || null));
  }, [o, i]), M(() => {
    c.current && c.current.volume(s ? w : I);
  }, [s]), M(() => () => {
    Howler.stop();
  }, []), S(Pe, {});
}, Pt = "scene://", tn = (o, t, n, r = !1) => {
  if (o.type === "modal")
    return "modal";
  if (console.log("clicked", r), o.type === "tourentry" && r)
    return o.linkSceneId;
  if (!o.href || !o.href[n]) {
    console.warn("Link has no href", o, n);
    return;
  }
  const s = o.href[n].split(Pt)[1];
  return s ? t.scenes[s] : o.href[n];
}, xn = ({ children: o, position: t = "absolute", x: n = "0%", y: r = "0%", anchor: s = "center" }) => S(kn, { position: t, dataX: n, dataY: r, anchor: s, className: "cue-video-story-animation-wrapper", children: S(Nn, { className: "cue-video-story-animation-button", children: o }) }), Nn = $e.div``, kn = $e.div(({ position: o, dataX: t, dataY: n, anchor: r }) => ({
  position: o,
  top: n,
  left: t,
  transform: (() => {
    let i = "none";
    return o === "absolute" && (i = "translateY(-50%)", r === "left" ? i += " translateX(0%)" : r === "center" ? i += " translateX(-50%)" : r === "right" && (i += " translateX(-100%)")), i;
  })()
})), Pn = (o) => {
  const [t, n] = A(!1), r = (s) => {
    if (n(s), o.blend) {
      const i = document.getElementById(`overlay_${o.linkId}`);
      s ? i == null || i.classList.add("active") : i == null || i.classList.remove("active");
    }
  };
  return ce(An, { className: "cue-video-story-highlight-wrapper", children: [S("div", { onMouseEnter: () => r(!0), onMouseLeave: () => r(!1), onClick: () => r(!1), children: o.children }), S(Ln, { className: `cue-video-story-highlight-image ${t ? "cue-video-story-highlight-image-active" : ""}`, image: o.image })] });
}, An = $e.div``, Ln = $e.div(({ image: o }) => `background-image: ${o ? `url("${o}") ` : "none"};`), et = "de", St = (o) => {
  const { i18n: { language: t } } = ze(), { sceneLink: n, showOnly: r, isMobile: s, linkHolderDimensions: i, buttonSafeZone: a = [20, 20, 20, 20], isGrouped: E = !1, linkHighlight: f, disableOverlay: u = !1 } = o, c = n.component || "DefaultButton", C = a, T = (1 - ((i == null ? void 0 : i.holder.x) || 1) / ((i == null ? void 0 : i.stage.x) || 1)) / 2, I = (1 - ((i == null ? void 0 : i.holder.y) || 1) / ((i == null ? void 0 : i.stage.y) || 1)) / 2, w = He(() => {
    var F, v;
    const h = C[0] / (((F = i == null ? void 0 : i.stage) == null ? void 0 : F.x) || 1), g = C[2] / (((v = i == null ? void 0 : i.stage) == null ? void 0 : v.x) || 1);
    let O = n.x || 0;
    return O < T + h && (O = T + h), O > 1 - T - g && (O = 1 - T - g), `${(100 * O).toFixed(2)}%`;
  }, [T, n.x, i, C]), N = He(() => {
    const h = C[1] / ((i == null ? void 0 : i.stage.y) || 1), g = C[3] / ((i == null ? void 0 : i.stage.y) || 1);
    let O = n.y || 0;
    return O < I + h && (O = I + h), O > 1 - I - g && (O = 1 - I - g), `${(100 * O).toFixed(2)}%`;
  }, [I, n.y, i, C]), k = He(() => {
    var h;
    if ((h = n.contents) != null && h.title)
      return !n.contents.title[t] && n.contents.title[et] ? n.contents.title[et] : n.contents.title[t];
  }, [n, t]), x = He(() => {
    var h;
    if ((h = n.contents) != null && h.active)
      return !n.contents.active[t] && n.contents.active[et] ? n.contents.active[et] : n.contents.active[t];
  }, [n, t]), d = He(() => {
    var h;
    if ((h = n.contents) != null && h.subtitle)
      return !n.contents.subtitle[t] && n.contents.subtitle[et] ? n.contents.subtitle[et] : n.contents.subtitle[t];
  }, [n, t]);
  if (r && !r.includes(c))
    return null;
  const _ = (h, g) => {
    if (h === "AutoplayButton")
      return setTimeout(() => {
        g.onSceneLinkClicked();
      }, 500), S(Pe, {});
    const O = g.sceneLink.icon ? g.sceneLink.icon : E ? "" : "arrowRight";
    return S(Pe, { children: S(Te, { styling: `videoStory-${n.component}${E ? "-grouped" : ""}`, className: `cue-button-videoStory ${!k && !d ? "cue-button-videoStory-no-content" : ""}
        ${f && f === n.linkSceneId ? ` cue-button-videoStory-${n.component}-hover` : ""}`, "data-link-id": n.linkIdInternal, "data-topic": n == null ? void 0 : n.topic, "data-link-icon": g.sceneLink.icon ? g.sceneLink.icon : "arrow", icon: g.sceneLink.icon_type && O ? [g.sceneLink.icon_type, O] : g.sceneLink.icon_type || O, onClick: () => g.onSceneLinkClicked(), onMouseEnter: () => g.onSceneLinkHover && g.onSceneLinkHover(n.linkSceneId || void 0, !0), onMouseLeave: () => g.onSceneLinkHover && g.onSceneLinkHover(n.linkSceneId || void 0, !1), children: (h === "DefaultButton" || s || h === "DarkButton") && n.contents && (k || d) && ce(Pe, { children: [k && S("div", { children: k }), d && S("div", { className: "subtitle", children: d })] }) }) });
  };
  return E && x ? S(Pe, { children: _("DefaultButton", { ...o, isGrouped: E }) }) : !n.component || !x ? null : n.active ? s ? _(n.component, o) : S(Pn, { image: u ? "" : (n == null ? void 0 : n.hover_overlay) || "", blend: u ? "" : n == null ? void 0 : n.hover_blend, blendMode: n == null ? void 0 : n.hover_blend_mode, linkId: n == null ? void 0 : n.linkId, children: S(xn, { x: w, y: N, anchor: n.anchor, children: _(n.component, o) }) }) : S(Pe, {});
};
var At;
(function(o) {
  o.Link = "Link", o.Scene = "Scene";
})(At || (At = {}));
var Oe;
(function(o) {
  o.VideoStart = "VIDEOSTART", o.VideoEnd = "VIDEOEND";
})(Oe || (Oe = {}));
var Ct = globalThis && globalThis.__assign || function() {
  return Ct = Object.assign || function(o) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (o[s] = t[s]);
    }
    return o;
  }, Ct.apply(this, arguments);
}, It = function() {
  return typeof window < "u" && !!window.document && !!window.document.createElement;
}, Dn = (
  /** @class */
  function() {
    function o() {
      var t = this;
      this.handleWheel = function(n) {
        n.preventDefault();
      }, this.handleScroll = function() {
        window.scrollTo.apply(window, t.lockToScrollPos);
      }, this.handleKeydown = function(n) {
        var r = t.options.keyboardKeys;
        ["INPUT", "TEXTAREA"].includes(n.target.tagName) && (r = r.filter(function(s) {
          return !t.options.authorizedInInputs.includes(s);
        })), r.includes(n.keyCode) && n.preventDefault();
      }, this.element = null, this.lockToScrollPos = [0, 0], this.options = {
        authorizedInInputs: [32, 37, 38, 39, 40],
        disableKeys: !0,
        disableScroll: !0,
        disableWheel: !0,
        keyboardKeys: [32, 33, 34, 35, 36, 37, 38, 39, 40]
      }, It() && (this.element = document.scrollingElement);
    }
    return o.prototype.on = function(t, n) {
      var r, s, i, a;
      if (It()) {
        this.element = t || this.element, this.options = Ct(Ct({}, this.options), n);
        var E = this.options, f = E.disableKeys, u = E.disableScroll, c = E.disableWheel;
        c && (document.addEventListener("wheel", this.handleWheel, { passive: !1 }), document.addEventListener("touchmove", this.handleWheel, { passive: !1 })), u && (this.lockToScrollPos = [(s = (r = this.element) === null || r === void 0 ? void 0 : r.scrollLeft) !== null && s !== void 0 ? s : 0, (a = (i = this.element) === null || i === void 0 ? void 0 : i.scrollTop) !== null && a !== void 0 ? a : 0], document.addEventListener("scroll", this.handleScroll, { passive: !1 })), f && document.addEventListener("keydown", this.handleKeydown, { passive: !1 });
      }
    }, o.prototype.off = function() {
      It() && (document.removeEventListener("wheel", this.handleWheel), document.removeEventListener("touchmove", this.handleWheel), document.removeEventListener("scroll", this.handleScroll), document.removeEventListener("keydown", this.handleKeydown));
    }, o;
  }()
);
const Wt = new Dn(), Gt = (o) => {
  const { onAction: t, buttonSafeZone: n, inTransition: r, disableVideos: s, ...i } = o, { headline: a, description: E, subline: f, cta_active: u, cta_label: c, cta_href: C, cta_type: T, custom_footer: I, custom_close: w, open: N, close_on_scene_change: k = !0 } = i, x = ee(null), d = ee(null), [_, h] = A(N), { i18n: { language: g } } = ze(), { dispatch: O } = vt(ht);
  if (M(() => {
    h(N), O({
      type: de.ToggleInfoBox,
      infoBoxOpen: N
    });
  }, [O, N]), M(() => {
    O({
      type: de.ToggleInfoBox,
      infoBoxOpen: _
    });
  }, [O, _]), r && k || !i || !Object.keys(i).length)
    return;
  const F = () => {
    t && t({
      action: T,
      params: { href: { [g]: C }, type: T }
    });
  }, v = () => {
    var p, V;
    x.current && d.current && ((p = x == null ? void 0 : x.current) == null ? void 0 : p.getBoundingClientRect().height) < ((V = d == null ? void 0 : d.current) == null ? void 0 : V.getBoundingClientRect().height) && Wt.on();
  };
  return ce("div", { className: `cue-video-story-info-box ${_ ? "cue-video-story-info-box-open" : ""} ${r ? "cue-video-story-info-box-in-transition" : ""}`, style: {
    "--safe-zone": `${(n == null ? void 0 : n[2]) || 0}px`
  }, children: [S("div", { className: "cue-video-story-info-box-button-holder", children: S(Te, { className: `cue-video-tour-description-${_ ? "close" : "info"}`, icon: _ ? "close" : "info", onClick: () => {
    w ? w() : h(!_);
  } }) }), " ", ce("div", { className: "cue-video-story-info-box-content", children: [S("div", { className: "cue-video-story-info-box-content-scroll", ref: x, children: S(Sn, { onMouseEnter: () => v(), onMouseLeave: () => Wt.off(), children: ce("div", { ref: d, children: [S(jt, { type: "h4", children: f }), a && S(jt, { type: "h3", children: a }), E && S(gn, { children: E })] }) }) }), (u || I) && S("div", { className: "cue-video-story-info-box-content-cta", children: I || S(Te, { onClick: F, children: c }) })] })] });
}, nn = zt({
  preloadedVideoFiles: /* @__PURE__ */ new Map()
}), tt = /* @__PURE__ */ new Map(), Vn = (o) => {
  const { i18n: { language: t } } = ze(), { children: n, currentScene: r, config: s, disabled: i, basePath: a, ignorePreloadErrors: E = !1 } = o, [f, u] = A(!1), c = ee(null), [C, T] = A(/* @__PURE__ */ new Map()), I = (k) => {
    var _;
    const x = (_ = c.current) == null ? void 0 : _.getBoundingClientRect(), d = ((x == null ? void 0 : x.width) ?? 0) * window.devicePixelRatio;
    return k.length === 0 ? 0 : k.map((h) => h.width).reduce((h, g) => Math.abs(g - d) < Math.abs(h - d) ? g : h);
  }, w = (k, x, d, _) => {
    const h = I(x), g = tt.get(k);
    if (!g || g != null && g.failedToLoad || h > g.width) {
      const O = x.find((v) => v.width === h) ?? x[0];
      if (!O)
        return Promise.resolve(new Response(""));
      if (i) {
        const v = Promise.resolve(new Response(`${a}${O.src}`));
        return O.blobSrc = `${a}${O.src}`, tt.set(k, O), d.push(v), v;
      }
      const F = fetch(`${a}${O.src}`).then(async (v) => {
        if (v.ok) {
          tt.set(k, O);
          const p = await v.blob();
          O.blobSrc = window.URL.createObjectURL(p), _ && N();
        } else
          console.warn("MISSING VIDEO", v), tt.set(k, { ...O, failedToLoad: !0 });
        return v;
      }).catch((v) => (console.error(v), tt.set(k, { ...O, failedToLoad: !0 }), v));
      d.push(F);
    }
  }, N = () => {
    T(() => new Map(tt));
  };
  return M(() => {
    const k = [], x = (d) => {
      var _;
      (_ = d.media) == null || _.forEach((h) => {
        w(h.mediaId, h.formats, k, !0);
      });
    };
    x(r), r == null || r.links.forEach((d) => {
      const _ = tn(d, s, t);
      _ && typeof _ != "string" && (x(_), d.formats && w(d.linkId, d.formats, k));
    }), Promise.all(k).then((d) => {
      N(), u(d.some((_) => !_.ok));
    });
  }, [r]), f && !E ? S("div", { className: "cue-video-story-loading-failed", children: "Loading failed" }) : S(nn.Provider, { value: { preloadedVideoFiles: C }, children: S("div", { ref: c, className: "cue-video-story-preloader", children: n }) });
}, pt = [], $n = (o) => {
  var W;
  const { videoStarted: t, videoFinished: n, displayMode: r, linkButtonHolder: s, mobileNaviPadding: i, disableVideos: a } = o, { isFullscreen: E } = Zt(), f = o.currentVideo, { loop: u, src: c, blobSrc: C } = f, T = Nt.isIOs(), I = Nt.isSafari(), w = T ? c : C, [N, k] = A([]), x = ee(null), d = ee(null), _ = ee(null), [h, g] = A(!1), O = ee(w || ""), F = ee(u), v = ee(1), p = () => {
    O && v.current > 1 && k([
      { blobSrc: O.current, loop: F.current }
    ]);
  }, V = (b, D) => {
    let G = !1, ae = !1;
    const te = () => {
      if (b.target instanceof HTMLVideoElement) {
        const Q = b.target;
        Q.paused && !ae && Q.play(), Q.currentTime > 0 && !G && (G = !0, t(Q.duration), g(!0), f.fade || p());
        const Ce = f.fade ? (f.fade + (I ? 400 : 300)) / 1e3 : 0.09;
        !u && Q.currentTime >= Q.duration - Ce && !ae && (n && n(), ae = !0);
      }
      pt[D] = requestAnimationFrame(te);
    };
    b.target instanceof HTMLVideoElement && (b.target.onanimationend = () => {
      p();
    }), pt[D] !== void 0 && cancelAnimationFrame(pt[D]), pt[D] = requestAnimationFrame(te);
  };
  M(() => {
    g(!1), w && (O.current = w, F.current = u, k((b) => {
      const D = b.length === 1 && b[0].blobSrc !== w ? [b[0], { blobSrc: w, loop: u }] : [{ blobSrc: w, loop: u }];
      return v.current = D.length, D;
    }));
  }, [w, u]);
  const L = () => {
    const b = x.current || d.current;
    if (b) {
      const { height: D } = b.getBoundingClientRect(), G = b.parentElement, { height: ae, width: te } = G ? G.getBoundingClientRect() : { width: 0, height: 0 };
      o.onResize && o.onResize({
        mobileNaviPadding: i,
        videoWidth: f.width ? f.width * (D / f.height) : te,
        videoHeight: D,
        containerWidth: te,
        containerHeight: ae
      });
    } else
      o.onResize && o.onResize({ mobileNaviPadding: i });
  };
  return M(() => {
    L();
  }, [i]), M(() => {
    setTimeout(() => {
      L();
    }, 100), setTimeout(() => {
      L();
    }, 400), setTimeout(() => {
      L();
    }, 800);
  }, [E]), M(() => (L(), window.addEventListener("resize", L), () => {
    window.removeEventListener("resize", L);
  }), [s]), a ? S("div", { className: "cue-video-story-video-wrapper-empty", style: { width: "100%", height: "100%" }, ref: d }) : ce("div", { className: "cue-video-story-video-wrapper", children: [!w && S("div", { className: "cue-video-story-video-loading", children: S(mn, {}) }), ce("div", { className: `cue-video-story-video-element ${r === "cover" ? "cue-video-story-video-element-cover" : ""} `, ref: _, children: [(W = o == null ? void 0 : o.hoverImages) == null ? void 0 : W.map(({ hover_blend_mode: b, hover_blend: D, linkId: G }) => S("img", { id: `overlay_${G}`, src: D, className: "cue-video-story-blend-overlay", style: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    mixBlendMode: b || "normal"
  } }, G)), N.map((b, D) => S("video", { style: {
    animationDuration: `${f.fade ? f.fade / 1e3 : 0}s`
  }, className: pn("cue-videocore-sequence", {
    loop: b.loop,
    fadeVideo: f.fade && N.length === 2 && D === 0 && h
  }), playsInline: !0, autoPlay: !0, ref: x, muted: !0, onLoadedMetadata: (G) => {
    V(G, D), L();
  }, loop: b.loop, onError: (G) => {
    console.log("Video Error", G), n && n();
  }, children: S("source", { src: b.blobSrc, type: f.type }) }, b.blobSrc))] })] });
}, Mn = (o) => {
  const { dispatch: t } = vt(ht), { preloadedVideoFiles: n } = vt(nn), { scene: r, changeSceneLink: s, onSequenceEnded: i, onShowSceneLinks: a, onHideSceneLinks: E, onVideoEvent: f, config: u, displayMode: c, linkButtonHolder: C, mobileNaviPadding: T = 0, disableVideos: I } = o, [w, N] = A(0), { i18n: { language: k } } = ze(), x = () => {
    N(0), i(), f && f({
      event: Oe.VideoEnd,
      scene: r
    });
  }, d = He(
    () => {
      var O, F;
      s && !s.formats && x();
      const h = r.media[w], g = s && s.formats ? n.get(s.linkId) ?? s.formats[0] : n.get(h.mediaId) ?? h.formats[0];
      return {
        src: (g == null ? void 0 : g.src) || "",
        blobSrc: g == null ? void 0 : g.blobSrc,
        loop: !s && h.loop === !0,
        width: (g == null ? void 0 : g.width) || 0,
        height: (g == null ? void 0 : g.height) || 0,
        type: (g == null ? void 0 : g.type) || "",
        failedToLoad: (g == null ? void 0 : g.failedToLoad) === !0,
        fade: s != null && s.fade ? s == null ? void 0 : s.fade : h.fade ?? 0,
        showLinks: !s && h.links === !0,
        audio: (F = (O = s == null ? void 0 : s.contents) == null ? void 0 : O.audio) == null ? void 0 : F[k]
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, w, s, n, k, u]
  ), _ = () => {
    d.loop || x();
  };
  return M(() => {
    d.showLinks ? a(r) : E(), s || x();
  }, [s, r]), M(() => {
    t({
      type: de.SaveCurrentScene,
      currentScene: {
        scene: r,
        key: r.sceneKey
      }
    });
  }, [r]), S(Pe, { children: S($n, { displayMode: c, currentVideo: d, videoFinished: _, hoverImages: r.links.filter((h) => h.hover_blend), linkButtonHolder: C, mobileNaviPadding: T, disableVideos: I || !d.src || d.failedToLoad, onResize: (h) => {
    o.onResize && o.onResize(h);
  }, videoStarted: (h, g) => {
    f && f({
      event: Oe.VideoStart,
      scene: r,
      video: {
        ...d,
        loopCount: g ?? 0,
        duration: h
      }
    });
  } }) });
}, Fn = (o) => {
  const { i18n: { language: t } } = ze(), { stateHandler: { setState: n, state: r }, isFullscreen: s = !1, onAction: i, onVideoEvent: a, onLinkHover: E, linkHighlight: f, startSceneKey: u, preloadAll: c, displayMode: C, onOffsetChange: T, onMobileNaviHeight: I, config: w, basePath: N, disablePreload: k, mobileActionIconsBottom: x, buttonSafeZone: d, mobileNaviPadding: _ = 0, version: h = "V2", overrideSceneName: g, infoBox: O, ignorePreloadErrors: F = !1, disableVideos: v = !1, disableOverlay: p = !1, language: V } = o, { state: L, dispatch: W } = vt(ht), [b, D] = A(w.scenes[u]), [G, ae] = A(null), [te, Q] = A(null), [Ce, Se] = A(), [ge, _e] = A(), [Ae, Ie] = A([]), [it, Ue] = A({ x: 0, y: 0 }), [pe, Le] = A(t), [Ke, Me] = A({
    holder: { x: 0, y: 0 },
    stage: { x: 0, y: 0 }
  }), re = ee(null), q = ee(null), We = Qt(
    ({ videoHeight: m, videoWidth: U, containerHeight: H, containerWidth: X }) => {
      var me;
      if (U && m && X && H) {
        const Y = U / m, be = X / H, Fe = C !== "cover" && s ? Y > be : Y < be;
        let fe = 0, ie = 0;
        Fe ? (fe = X, ie = fe / Y) : (ie = H, fe = ie * Y);
        const ve = (me = re == null ? void 0 : re.current) == null ? void 0 : me.getBoundingClientRect();
        Me({
          holder: {
            x: X,
            y: H
          },
          stage: {
            x: (ve == null ? void 0 : ve.width) || X,
            y: (ve == null ? void 0 : ve.height) || H
          }
        });
        const Qe = {
          x: Math.round((X - fe) / 2),
          y: Math.round((H - ie) / 2)
        };
        Ue(Qe), T && T(Qe);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      C,
      T,
      re == null ? void 0 : re.current,
      q == null ? void 0 : q.current
    ]
  ), Ge = () => {
    if (q.current) {
      const m = (q.current.getBoundingClientRect().height || 0) + _;
      q.current.style.bottom = `-${m}px`, I && I(m);
    }
  };
  M(() => (Ge(), window.addEventListener("resize", Ge), () => {
    window.removeEventListener("resize", Ge);
  }), [_]), M(() => {
    var m;
    Se((m = b == null ? void 0 : b.scene_name) == null ? void 0 : m[t]);
  }, [b, t]), M(() => {
    if (v)
      if (r) {
        const m = w.scenes[r];
        D(m), Ie([]), setTimeout(() => {
          const U = w.scenes[r];
          D(U), Ie(U.links);
        }, 250);
      } else
        Ie(b.links);
  }, [r]);
  const we = (m) => {
    var H, X, me, Y, be, Fe, fe;
    if (!w)
      return;
    if (m.content_box_enabled) {
      ae({
        open: !0,
        headline: (X = (H = m.content_box) == null ? void 0 : H.headline) == null ? void 0 : X[t],
        description: (Y = (me = m.content_box) == null ? void 0 : me.content) == null ? void 0 : Y[t],
        cta_active: !0,
        cta_label: (Fe = (be = m.content_box) == null ? void 0 : be.button_label) == null ? void 0 : Fe[t],
        cta_type: m.type,
        cta_href: (fe = m.href) == null ? void 0 : fe[t],
        custom_close: () => ae(null)
      });
      return;
    }
    const U = tn(m, w, V || t, !0);
    U && (typeof U == "string" ? i && i({
      action: m.type,
      params: m
    }) : (v && i && i({
      action: At.Scene,
      params: U
    }), b && a && a({
      event: Oe.VideoStart,
      scene: b
    }), m != null && m.linkSceneId && !v && n(m.linkSceneId), D(U), _e(m)));
  }, ne = (m) => {
    var U, H, X;
    if (m.action === "scene") {
      const me = (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ((X = (H = (U = m == null ? void 0 : m.params) == null ? void 0 : U.href) == null ? void 0 : H[t]) == null ? void 0 : X.replace(Pt, "")) || ""
      );
      me && n(me);
    } else
      i && i(m);
  };
  return M(() => {
    const m = pe !== t;
    if (L.changeSceneToKey || m) {
      const U = L.changeSceneToKey;
      if (U && (U !== b.sceneKey || m) && (Le(t), w && w.scenes[U])) {
        D(w.scenes[U]);
        const H = b == null ? void 0 : b.links.find((X) => X.href && X.href[t] && X.href[t].includes(`${Pt}${U}`));
        _e(H);
      }
      W({
        type: de.ChangeScene,
        changeSceneToKey: void 0
      });
    }
  }, [L.changeSceneToKey, w, t]), ce(Vn, { config: w, basePath: N, currentScene: b, preloadAll: c, disabled: k || v, ignorePreloadErrors: F, children: [S(In, { soundOn: o.soundOn, dimSound: o.dimSound, background: ge || b == null ? void 0 : b.background, backgroundTranslations: ge || b == null ? void 0 : b.background_translations, transition: te || void 0, language: t || V }), h == "V2" && (Ce || g) && !ge && S("div", { className: "cue-video-story-scene-name", children: g || Ce }), h === "V2" && ce(Pe, { children: [S(Gt, { ...O, inTransition: L == null ? void 0 : L.inTransition, buttonSafeZone: d, onAction: ne, disableVideos: v }), S(Gt, { ...G, buttonSafeZone: d, inTransition: L == null ? void 0 : L.inTransition, onAction: ne, disableVideos: v })] }), S(Mn, { config: w, onVideoEvent: (m) => {
    var U;
    a && a(m), m.event === Oe.VideoStart && m.video && !m.video.loop && Q(((U = m == null ? void 0 : m.video) == null ? void 0 : U.audio) || null);
  }, scene: b, changeSceneLink: ge, onSequenceEnded: () => {
    _e(void 0), W({
      type: de.SceneChanged
    });
  }, onShowSceneLinks: (m) => {
    v || Ie(m.links);
  }, onHideSceneLinks: () => Ie([]), displayMode: C, onResize: We, linkButtonHolder: re == null ? void 0 : re.current, mobileNaviPadding: _, disableVideos: v }), S(Bn, { className: "cue-video-story-button-holder", positionOffset: it, ref: re, children: Ae.filter(({ is_grouped: m }) => !m).map((m) => S(St, { onSceneLinkClicked: () => {
    we(m);
  }, sceneLink: m, disableOverlay: p, linkHolderDimensions: Ke, buttonSafeZone: d, onSceneLinkHover: (U, H) => E && E(U, H), linkHighlight: f }, m.linkId)) }), h !== "V2" && ce(jn, { ref: q, className: "cue-video-story-button-holder-mobile", children: [Ae.filter(({ component: m }) => x ? !0 : m && ["DefaultButton", "EnterButton"].includes(m)).map((m) => S(St, { isMobile: !0, onSceneLinkClicked: () => we(m), sceneLink: m }, m.linkId)), x && Ae.filter(({ component: m }) => m && ["PlayButton", "InfoButton", "StoryApp"].includes(m)).map((m) => S(St, { isMobile: !0, onSceneLinkClicked: () => we(m), sceneLink: m }, m.linkId))] }), S(Hn, { className: "cue-video-story-button-holder-grouped", style: {
    "--safe-zone": `${(d == null ? void 0 : d[2]) || 0}px`
  }, children: S("div", { children: Ae.filter(({ is_grouped: m }) => m).map((m) => ce("div", { children: [S(St, { isGrouped: !0, onSceneLinkClicked: () => we(m), sceneLink: m }, m.linkId), S("div", { className: "cue-video-story-button-holder-grouped-divider" })] }, m.linkId)) }) })] });
}, Bn = $e.div(({ positionOffset: { x: o, y: t } }) => `
    top: ${t}px;
    left: ${o}px;
    right: ${o}px;
    bottom: ${t}px;
  `), Hn = $e.div``, jn = $e.div``, Un = (o, t) => {
  const n = (i, a = "en") => {
    var f, u;
    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ((u = (f = i == null ? void 0 : i.src_translations) == null ? void 0 : f.find(
        (c) => c.lang === a
      )) == null ? void 0 : u.src) || i.src
    );
  }, r = (i, a, E, f) => {
    if (i == null)
      throw new Error(`Config Error ${f || ""} - ${a} - ${JSON.stringify(E)}`);
    return i;
  };
  if (!o.scenes)
    throw new Error("Config Error - Scenes are missing");
  const s = {
    scenes: {},
    startscene: o.startscene
  };
  return Object.entries(o.scenes).forEach(([i, a]) => {
    var E, f;
    s.scenes[i] = {
      sceneId: ft(),
      sceneKey: i,
      name: a.name,
      position: a.position,
      scene_name: a.scene_name,
      exit_scene: ((E = a == null ? void 0 : a.exit_scene) == null ? void 0 : E.id) || null,
      info_box: (a == null ? void 0 : a.info_box) || null,
      media: r(a.media.map((u) => ({
        mediaId: ft(),
        id: u.id,
        links: u.links === !0,
        loop: u.loop === !0,
        fade: u.fade,
        formats: u.formats.map((c) => ({
          type: r(c.type, "media type is missing", c, a.name),
          src: r(n(c, t), "media src is missing", c, a.name).replace('"', ""),
          width: r(c.width, "media width is missing", c, a.name),
          height: r(c.height, "media height is missing", c, a.name)
        }))
      })), "Scene is missing media", a),
      // eslint-disable-next-line
      // @ts-ignore
      links: r(a.links.map((u) => {
        var c, C, T, I, w;
        return {
          linkId: ft(),
          linkIdInternal: u.id,
          linkSceneId: ((c = u == null ? void 0 : u.scene) == null ? void 0 : c.id) || null,
          // need for home Button
          fade: u.fade,
          href: u.href,
          active: u.active,
          audio: u.audio,
          type: u.type,
          anchor: u.anchor,
          // Links without component can be used to define transition to other scenes without generating a button
          component: u.component,
          icon: ((C = u == null ? void 0 : u.icon) == null ? void 0 : C.component) || null,
          icon_type: ((T = u == null ? void 0 : u.icon_type) == null ? void 0 : T.component) || null,
          is_grouped: (u == null ? void 0 : u.is_grouped) || !1,
          topic: ((I = u == null ? void 0 : u.topic) == null ? void 0 : I.id) || null,
          hover_overlay: u.hover_overlay,
          hover_blend: u.hover_blend,
          hover_blend_mode: u.hover_blend_mode,
          position: u.position,
          x: u.component ? r(u.x, "link x position is missing", u, a.name) : void 0,
          y: u.component ? r(u.y, "link y position is missing", u, a.name) : void 0,
          contents: u.contents ? {
            title: u.contents.title,
            subtitle: u.contents.subtitle,
            active: u.contents.active,
            audio: u.contents.audio
          } : void 0,
          content_box: u.content_box,
          content_box_enabled: u.content_box_enabled,
          formats: (w = u.formats) == null ? void 0 : w.map((N) => ({
            type: r(N.type, "type is missing", N, a.name),
            src: r(n(N, t), "src is missing", N, a.name),
            width: r(N.width, "width is missing", N, a.name),
            height: r(N.height, "height is missing", N, a.name)
          }))
        };
      }), "Scene is missing links", a),
      background: a.background ? {
        loop: a.background.loop === !0,
        volume: a.background.volume ?? 0,
        formats: (f = a.background.formats) == null ? void 0 : f.map((u) => ({
          src: r(n(u, t), "src is missing", u, a.name),
          type: r(u.type, "type is missing", u, a.name)
        }))
      } : void 0,
      background_translations: a.background_translations,
      additionalContent: a == null ? void 0 : a.additional_content,
      layerContent: a == null ? void 0 : a.layer_content
    };
  }), s;
}, Kn = (o) => {
  const { icon: t, active: n, disabled: r, onToggle: s } = o, [i, a] = A(n);
  return M(() => {
    a(n);
  }, [n]), S(Te, { styling: "videoStory-Nav-Quit", className: `cue-video-story-navigation-nav cue-video-story-navigation  ${r ? "cue-video-story-navigation-nav-disabled" : ""} ${i ? "cue-video-story-navigation-nav-active" : ""}`, icon: t, onClick: () => {
    s(!i), a(!i);
  } });
}, Wn = (o) => {
  const { onLanguageChanged: t, btnStyling: n, languages: r } = o, [s, i] = A(!1), { i18n: a } = ze(), E = ee(null), f = Qt((c) => {
    E.current && !c.composedPath().includes(E.current) && (i(!1), document.removeEventListener("click", f));
  }, []);
  return ce("div", { className: "cue-video-story-navigation-language", children: [S(Te, { styling: n, icon: "language", className: `cue-video-story-navigation-nav cue-video-story-navigation-nav-language ${s ? "cue-video-story-navigation-nav-active" : ""}`, onClick: (c) => {
    const C = !s;
    i(C), c.stopPropagation(), C ? document.addEventListener("click", f) : document.removeEventListener("click", f);
  } }), S(Gn, { ref: E, className: `cue-video-story-navigation-language-overlay ${s ? "cue-video-story-navigation-language-overlay-active" : ""}`, children: S(Cn, { languages: r, action: ({ value: c }) => {
    a == null || a.changeLanguage(c), t && t(c), i(!1);
  } }) })] });
}, Gn = $e.div``;
var Z;
(function(o) {
  o.HOME = "HOME", o.LANGUAGE = "LANGUAGE", o.BACK = "BACK", o.HISTORYBACK = "HISTORYBACK", o.SOUND = "SOUND", o.FULLSCREEN = "FULLSCREEN", o.QUIT = "QUIT", o.DIVIDER = "DIVIDER", o.EXTRA = "EXTRA";
})(Z || (Z = {}));
const Yn = Xt(function(t, n) {
  const { stateHandler: { setState: r, state: s }, onSoundClicked: i, isSoundOn: a, onLanguageChanged: E, languages: f, onFullScreen: u, onQuit: c, isFullscreen: C, startScene: T, currentScene: I, playerCurrentScene: w, include: N = [], exclude: k = [], type: x = "default", menuExtraRenderer: d, buttonSafeZone: _ } = t, h = k;
  Nt.isIOs() && h.push(Z.FULLSCREEN);
  const g = `videoStoryMenu${x !== "default" ? x.charAt(0).toUpperCase() + x.slice(1) : ""}`;
  if (N === null)
    return null;
  const O = S(Te, { icon: "home", "data-test-id": "cue-test-video-nav-home", styling: "videoStory-Nav-Home", className: `cue-video-story-navigation-nav cue-video-story-navigation-nav-home ${s === "" || s === T ? "cue-video-story-navigation-nav-disabled" : ""}`, onClick: () => {
    s !== T && r(T);
  } }, "menu-home"), F = S(Te, { icon: "undo", "data-test-id": "cue-test-video-nav-back", styling: "videoStory-Nav-History-Back", className: "cue-video-story-navigation-nav cue-video-story-navigation-nav-history-back", onClick: () => {
    history.back();
  } }, "menu-history-back"), v = f && (f == null ? void 0 : f.length) > 1 && S(Wn, { languages: f, onLanguageChanged: E, btnStyling: g }, "menu-language-switch"), p = S(Te, { icon: "back", className: `cue-video-story-navigation-nav cue-video-story-navigation-nav-back ${I != null && I.exit_scene ? "" : "cue-video-story-navigation-nav-disabled"}`, styling: "videoStory-Nav-Back", onClick: () => {
    const te = I != null && I.exit_scene ? I.exit_scene : T;
    r(te);
  } }, "menu-back"), V = S(Te, { styling: "videoStory-Nav-Sound", className: "cue-video-story-navigation-nav cue-video-story-navigation-nav-sound", icon: a ? "soundOn" : "soundOff", onClick: i }, "menu-sound"), L = S(Te, { styling: "videoStory-Nav-Fullscreen", className: "cue-video-story-navigation-nav cue-video-story-navigation-nav-fullscreen", icon: C ? "fullscreenOn" : "fullscreenOff", onClick: u }, "menu-fulscreen"), W = S(Te, { styling: "videoStory-Nav-Quit", className: "cue-video-story-navigation-nav cue-video-story-navigation--nav-quit", icon: "quit", onClick: c }, "menu-quit"), b = S("div", { className: "cue-video-story-navigation-extra", children: d }), D = S("div", { className: "cue-video-story-navigation-divider" }), G = (te) => {
    switch (te) {
      case Z.HOME:
        return O;
      case Z.HISTORYBACK:
        return F;
      case Z.LANGUAGE:
        return v;
      case Z.BACK:
        return p;
      case Z.SOUND:
        return V;
      case Z.FULLSCREEN:
        return L;
      case Z.QUIT:
        return W;
      case Z.DIVIDER:
        return D;
      case Z.EXTRA:
        return b;
      default:
        return;
    }
  }, ae = () => {
    let te = !0;
    return N.map((Q, Ce) => {
      var Se;
      if (typeof Q == "string") {
        const ge = G(Q);
        return Q === Z.DIVIDER ? te && ge : ((Se = ge.props.className) != null && Se.includes("nav-disabled") || (te = !0), ge);
      } else
        return S(Kn, { ...Q }, Ce);
    });
  };
  return S(qn, { ref: n, className: "cue-video-story-navigation", children: S("div", { className: `cue-video-story-navigation-wrapper  cue-video-story-navigation-wrapper-${x} ${C ? "cue-video-story-navigation-wrapper-fullscreen" : ""} ${w !== s ? "cue-video-story-navigation-wrapper-in-transition" : ""}`, style: {
    "--safe-zone": `${(_ == null ? void 0 : _[2]) || 0}px`
  }, children: S("div", { className: "scrollbar-container", children: (N == null ? void 0 : N.length) > 0 ? S(Pe, { children: ae() }) : ce(Pe, { children: [!h.includes(Z.HOME) && O, !h.includes(Z.HISTORYBACK) && F, !h.includes(Z.LANGUAGE) && v, !h.includes(Z.BACK) && p, !h.includes(Z.SOUND) && V, !h.includes(Z.FULLSCREEN) && L, !h.includes(Z.QUIT) && W, d && b] }) }) }) });
}), qn = $e.div``, Co = "experience", _o = "showroom";
console.debug('@cue/videostorycore "3.6.2"');
const wo = Xt(function(t, n) {
  const { stateHandler: r, trackingHandler: s, onOffsetChange: i, onLanguageChanged: a, languages: E = ["en"], onQuit: f, fsWrapper: u, disablePreload: c, onAction: C, onVideoEvent: T, onEnterScene: I, onExitScene: w, onLinkHover: N, linkHighlight: k, primaryMenuInclude: x = [], secondaryMenuInclude: d = [], primaryMenuExclude: _ = [], secondaryMenuExclude: h = [], showPrimaryMenu: g = !0, showSecondaryMenu: O = !0, primaryMenuExtraRenderer: F, secondaryMenuExtraRenderer: v, basePath: p = "", initSceneKey: V, mobileActionIconsBottom: L, buttonSafeZone: W = [20, 20, 20, 20], mobileNaviPadding: b = 0, version: D = "V2", ratio: G = "16/9", hideInvalidLinks: ae = !1, overrideSceneName: te, infoBox: Q, ignorePreloadErrors: Ce = !1, disableVideos: Se = !1, disableOverlay: ge = !1, overrideInTransition: _e, language: Ae, onInfoBoxOpen: Ie } = t, [it, Ue] = A(!1), [pe, Le] = A(Q);
  M(() => Le(Q), [Q]), M(() => {
    F && console.warn("primaryMenuExtraRenderer is deprecated");
  }, [F]), M(() => {
    v && console.warn("secondaryMenuExtraRenderer is deprecated");
  }, [v]), M(() => {
    L && D === "V2" && console.warn("mobileActionIconsBottom is deprecated");
  }, [L, D]);
  const { hash: Ke, updateHash: Me } = bn(), re = r || {
    setState: Me,
    state: Ke
  }, { state: q, initState: We } = re, { t: Ge, i18n: { language: we } } = ze(), ne = Ae || we, m = ee(), U = ee();
  vn(n, () => ({
    primaryMenu: m.current,
    secondaryMenu: U.current
  }), []);
  const H = He(() => {
    const R = Un(t.config, ne);
    if (ae) {
      const ye = { ...R, scenes: {} };
      for (const ue in R.scenes) {
        const Re = R.scenes[ue], De = Re.links.filter((ke) => {
          var qe;
          return ke.type === "fairtouch" && !((qe = ke == null ? void 0 : ke.href) != null && qe[ne]) ? !1 : ke;
        });
        ye.scenes[Re.sceneKey] = { ...Re, links: De };
      }
      return ye;
    }
    return R;
  }, [t.config, ne, ae]), { scenes: X, startscene: me } = H, [Y, be] = A(H.scenes[t.startSceneKey]), { saveSoundStatus: Fe, savedSoundStatus: fe } = En(), { isFullscreen: ie, enter: ve, exit: Qe } = Zt(), Ye = ee(null), [xe, Xe] = A(We || V || t.startSceneKey), [gt, wt] = A(We || V || t.startSceneKey), Rt = He(() => {
    var R;
    return ((R = Y == null ? void 0 : Y.info_box) == null ? void 0 : R[ne]) || null;
  }, [Y, ne]), { dispatch: at, state: { inTransition: Tt, infoBoxOpen: mt } } = vt(ht);
  M(() => {
    Ie && Ie(mt);
  }, [mt]);
  const yt = (R) => R ? !!X[R] : !1;
  M(() => {
    t.onFullscreenchange && t.onFullscreenchange(ie);
  }, [ie]), M(() => {
    be(H.scenes[xe]), t.onSceneChanged && xe && t.onSceneChanged({
      event: Oe.VideoEnd,
      scene: H.scenes[xe]
    });
  }, [ne]);
  const st = (R) => {
    var Ne, ye, ue, Re, De, ke, qe;
    Y || be(R.scene), (Ne = R.video) != null && Ne.loop || R.event === Oe.VideoEnd && (t.onSceneChanged && t.onSceneChanged(R), Be(R), be(R.scene)), R.event === Oe.VideoEnd && ((!it || R.scene.sceneKey !== (Y == null ? void 0 : Y.sceneKey)) && (I && I(R.scene), s && R.scene && !Se && (s && s.startSession({
      sceneId: (ye = R.scene) == null ? void 0 : ye.sceneKey,
      sceneName: ((ue = R.scene) == null ? void 0 : ue.name) || "",
      position: ((Re = R.scene) == null ? void 0 : Re.position) || ""
    }), s.enterScene({
      sceneId: (De = R.scene) == null ? void 0 : De.sceneKey,
      sceneName: ((ke = R.scene) == null ? void 0 : ke.name) || "",
      position: ((qe = R.scene) == null ? void 0 : qe.position) || ""
    })), Ue(!0)), pe && (pe == null ? void 0 : pe.close_on_scene_change) === !1 && Le(null)), R.event === Oe.VideoStart && R.video && !R.video.loop && (w && w(R.scene), s && (s == null || s.exitScene()));
  }, ct = (R) => {
    at({
      type: de.ChangeScene,
      changeSceneToKey: R
    });
  };
  M(() => {
    gt === xe && (ct(xe || ""), setTimeout(() => {
      at({
        type: de.SceneChanged
      });
    }, 100)), Xe(t.scene || "");
  }, [t.scene, ne]), M(() => {
    if (q) {
      const R = q || me;
      yt(R) && ct(R || ""), Xe(R || "");
    }
  }, [q, ne]);
  const Be = (R) => {
    wt(R.scene.sceneKey), R.scene.sceneKey !== xe && xe && setTimeout(() => {
    }, 100);
  };
  M(() => {
    Se && (be(H.scenes[q]), console.log("config.scenes[state]", H.scenes[q]), H.scenes[q] && T({
      event: Oe.VideoEnd,
      scene: H.scenes[q]
    }));
  }, [re.state]);
  const Je = ({ include: R, exclude: Ne, type: ye, ref: ue, menuExtraRenderer: Re, buttonSafeZone: De = [0, 0, 0, 0] }) => S(Yn, { stateHandler: re, type: ye, ref: ue, isSoundOn: fe, currentScene: Y, languages: E, playerCurrentScene: gt, startScene: me, menuExtraRenderer: Re, onLanguageChanged: a || (() => {
  }), onSoundClicked: () => Fe(!fe), isFullscreen: ie, onFullScreen: () => {
    ie ? Qe() : ve((u == null ? void 0 : u.current) || (Ye == null ? void 0 : Ye.current));
  }, onQuit: f || (() => {
  }), exclude: Ne, include: R, version: D, buttonSafeZone: De });
  M(() => {
    at({
      type: de.ToggleTransition,
      inTransition: _e
    });
  }, [_e]);
  const ut = _e !== void 0 ? _e : Tt && !Se;
  return ce("div", { ref: Ye, className: `cue-video-story-fullscreen-wrapper ${ie ? "cue-video-story-is-fullscreen" : ""} cue-video-story-${ie ? "cover" : t.displayMode}
        ${ut ? "cue-video-story-in-transition" : ""}`, style: { "--ratio": G }, children: [S("div", { className: "cue-video-story-turn-your-device", children: ce("div", { children: [S("div", { className: "cue-video-story-turn-your-device-icon", children: S(yn, { name: "tiltdevice" }) }), S("div", { className: "cue-video-story-turn-your-device-msg", children: Ge("video-story.tilt-your-device") })] }) }), ce("div", { className: `cue-video-story-navigation-holder cue-video-story-navigation-holder-${ie ? "cover" : t.displayMode}`, children: [g && Je({
    exclude: _,
    include: x,
    type: "primary",
    ref: m
  }), O && Je({
    include: d,
    exclude: h,
    type: "secondary",
    ref: U,
    buttonSafeZone: W
  })] }), S(Fn, { stateHandler: re, language: ne, disablePreload: c, startSceneKey: (yt(q) ? q : We || V || t.startSceneKey) || "", soundOn: fe, onAction: (R) => {
    var Ne, ye;
    if (s && (R == null ? void 0 : R.action) === "fairtouch") {
      const ue = R.params;
      s.openContent({
        contentId: (ue == null ? void 0 : ue.linkIdInternal) || "",
        position: (Y == null ? void 0 : Y.position) || "",
        title: ((ye = (Ne = ue == null ? void 0 : ue.contents) == null ? void 0 : Ne.title) == null ? void 0 : ye[ne]) || ""
      });
    }
    C && C(R);
  }, onVideoEvent: (R) => {
    st(R), T && T(R);
  }, onLinkHover: N, linkHighlight: k, preloadAll: t.preloadAll, dimSound: t.dimSound, displayMode: ie ? "cover" : t.displayMode, onOffsetChange: i, config: H, basePath: p, mobileActionIconsBottom: L, buttonSafeZone: W, mobileNaviPadding: b, version: D, overrideSceneName: te, infoBox: pe === !1 ? !1 : pe || Rt, ignorePreloadErrors: Ce, disableVideos: Se, disableOverlay: ge, isFullscreen: ie })] });
});
var Yt;
(function(o) {
  o[o.StartSceneKeyNotValid = 0] = "StartSceneKeyNotValid", o[o.TransformerError = 1] = "TransformerError";
})(Yt || (Yt = {}));
var zn = function(t) {
  var n = t.initValue, r = t.useHookBody, s = t.applyStateChange, i = ee(n);
  if (typeof r != "function")
    throw new Error("function expected as hook body parameter. got " + typeof r);
  var a = r();
  return hn(function() {
    i.current !== a && (i.current = a, s(a));
  }, [s, a]), null;
}, Lt, bt = _n;
if ({ USE_LOCATION_HASH: !0, SHOW_SHOWROOM_NAVIGATION_MENU: !0, APP_VERSION: '"3.6.2"' }.NODE_ENV === "production")
  Lt = bt.createRoot, bt.hydrateRoot;
else {
  var qt = bt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  Lt = function(o, t) {
    qt.usingClientEntryPoint = !0;
    try {
      return bt.createRoot(o, t);
    } finally {
      qt.usingClientEntryPoint = !1;
    }
  };
}
var Dt = function(t) {
  console && console.warn && console.warn(t);
}, xt = typeof self == "object" && self.self === self && self || typeof global == "object" && global.global === global && global || globalThis, Qn = function(t) {
  return wn(t);
}, Xn = function(t) {
  if (xt.document && xt.document.createElement) {
    var n = xt.document.createElement("div"), r = Lt(n);
    r.render(/* @__PURE__ */ rt.createElement(t, {
      automaticContainerInternalUseOnly: !0
    }));
  } else
    Dt("Can not mount SingletonHooksContainer on server side. Did you manage to run useEffect on server? Please mount SingletonHooksContainer into your components tree manually.");
};
function Vt() {
  return Vt = Object.assign ? Object.assign.bind() : function(o) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (o[r] = n[r]);
    }
    return o;
  }, Vt.apply(this, arguments);
}
var Jn = 1, $t = !1, on = !1, Et = [], nt = [], _t = function() {
  nt.forEach(function(t) {
    return t();
  });
}, Zn = function(t) {
  var n = t.automaticContainerInternalUseOnly, r = A([]), s = r[0], i = r[1], a = ee();
  return a.current = s, !n && $t === !1 && (on = !0), M(function() {
    var E = !0;
    function f() {
      if (E) {
        if (nt[0] !== f) {
          !n && $t === !0 && Dt("SingletonHooksContainer is mounted after some singleton hook has been used.Your SingletonHooksContainer will not be used in favor of internal one."), i(function(u) {
            return [];
          });
          return;
        }
        i([].concat(Et));
      }
    }
    return nt.push(f), _t(), function() {
      E = !1, a.current.length > 0 && Dt("SingletonHooksContainer is unmounted, but it has active singleton hooks. They will be reevaluated once SingletonHooksContainer is mounted again"), nt.splice(nt.indexOf(f), 1), _t();
    };
  }, [n]), /* @__PURE__ */ rt.createElement(rt.Fragment, null, s.map(function(E) {
    var f = E.hook, u = E.key;
    return /* @__PURE__ */ rt.createElement(zn, Vt({}, f, {
      key: u
    }));
  }));
}, eo = function(t) {
  var n = Jn++;
  return Et.push({
    hook: t,
    key: n
  }), nt.length === 0 && on === !1 && ($t = !0, Xn(Zn)), _t(), function() {
    Et.splice(Et.findIndex(function(r) {
      return r.key === n;
    }), 1), _t();
  };
}, rn = function(t, n, r) {
  r === void 0 && (r = {});
  var s = !1, i = void 0, a = !1, E = void 0, f = [], u = r, c = u.unmountIfNoConsumers, C = c === void 0 ? !1 : c, T = function(N) {
    E = N, Qn(function() {
      return f.forEach(function(k) {
        return k(N);
      });
    });
  }, I = function() {
    return a || (E = typeof t == "function" ? t() : t, a = !0), E;
  };
  return function() {
    var w = A(I), N = w[0], k = w[1];
    return M(function() {
      return s || (s = !0, i = eo({
        initValue: t,
        useHookBody: n,
        applyStateChange: T
      })), f.push(k), E !== N && k(E), function() {
        f.splice(f.indexOf(k), 1), f.length === 0 && C && (i(), s = !1);
      };
    }, []), N;
  };
}, je;
let to = (je = class {
  constructor() {
    he(this, "queue", []);
    he(this, "inited", !1);
    he(this, "debugEnabled", !1);
    he(this, "customSessionId", "");
    he(this, "currentScene");
    he(this, "currentTour");
    if (je._instance)
      return je._instance;
    this.inited = !1, this.queue = [];
  }
  getQueue() {
    return this.queue;
  }
  addToQueue(t) {
    if (t.action === "startSession") {
      if (this.inited)
        return;
      this.inited = !0;
    }
    this.queue.push(t);
  }
  setDebugEnabled() {
    this.debugEnabled = !0;
  }
  getDebugEnabled() {
    return this.debugEnabled;
  }
  setCustomSessionId(t) {
    this.customSessionId = t;
  }
  getCustomSessionId() {
    return this.customSessionId;
  }
  setCurrentScene(t) {
    this.currentScene = { ...t, duration: Date.now() };
  }
  getCurrentScene() {
    return this.currentScene;
  }
  setCurrentTour(t) {
    this.currentTour = t;
  }
  getCurrentTour() {
    return this.currentTour;
  }
  isInited() {
    return this.inited;
  }
}, he(je, "_instance", new je()), je);
const oe = new to(), no = {
  debuggingEnabled: () => {
    oe.setDebugEnabled();
  },
  customSessionId: (o) => {
    oe.setCustomSessionId(o);
  },
  startSession: (o) => {
    oe.setCurrentScene(o), oe.addToQueue({ action: "startSession", data: o });
  },
  enterScene: (o) => {
    oe.setCurrentScene({ ...o, duration: Date.now() }), oe.addToQueue({
      action: "enterScene",
      data: { ...o, duration: Date.now(), contentDuration: 0 }
    });
  },
  exitScene: () => {
  },
  enterTour: (o, t) => {
    const n = oe.getCurrentScene();
    oe.setCurrentTour({
      ...o,
      duration: Date.now(),
      visited: [o.tourStep],
      visitedPercentage: 0
    });
    const r = n != null && n.sceneId ? { ...n, ...o } : { ...t, ...o }, { totalSteps: s, ...i } = r;
    oe.addToQueue({
      action: "enterTour",
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore // TODO
      data: i
    });
  },
  pushTourStep: () => {
  },
  exitTour: () => {
  },
  openContent: () => {
  },
  closeContent: () => {
  }
}, oo = {
  customSessionId: {
    type: "sessionid",
    action: "start"
  },
  startSession: {
    type: "session",
    action: "start"
  },
  enterScene: {
    type: "scene",
    action: "enter"
  },
  exitScene: {
    type: "scene",
    action: "exit"
  },
  enterTour: {
    type: "tour",
    action: "enter"
  },
  exitTour: {
    type: "tour",
    action: "exit"
  },
  openContent: {
    type: "content",
    action: "open"
  },
  closeContent: {
    type: "content",
    action: "close"
  }
}, ro = () => {
  const [o, t] = A(), [n, r] = A(), [s, i] = A(oe.getCustomSessionId() || ft()), [a, E] = A(oe.getDebugEnabled()), [f, u] = A(oe.isInited()), [c, C] = A(), [T, I] = A(0);
  M(() => {
    oe.getQueue().forEach(({ action: p, data: V }) => {
      if (p == "enterScene") {
        const { duration: L, ...W } = V;
        v(p, W);
      } else
        v(p, V);
    }), oe.getDebugEnabled() && E(!0), oe.getCurrentScene() && C(oe.getCurrentScene()), oe.getCurrentTour() && r(oe.getCurrentTour());
  }, []);
  const w = () => E(!0), N = (p) => i(p), k = (p) => {
    C(p), f || v("startSession", { ...p }), u(!0);
  }, x = (p) => {
    C({ ...p, duration: Date.now(), contentDuration: 0 }), I(0), v("enterScene", p);
  }, d = () => {
    if (c) {
      const p = {
        ...c,
        duration: (Date.now() - ((c == null ? void 0 : c.duration) || Date.now())) / 1e3,
        contentDuration: T / 1e3
      };
      v("exitScene", p);
    }
  }, _ = (p, V) => {
    if ((n == null ? void 0 : n.tourId) === p.tourId)
      return;
    r({
      ...p,
      duration: Date.now(),
      visited: [p.tourStep],
      visitedPercentage: 0
    });
    const W = {
      ...c || V,
      ...p
    }, { totalSteps: b, ...D } = W;
    v("enterTour", D);
  }, h = () => {
    if (!n)
      return console.warn(" NO CURENT TOUR FOR exitTour()");
    const p = [...new Set(n == null ? void 0 : n.visited)].sort((W, b) => W - b), { totalSteps: V, ...L } = n;
    v("exitTour", {
      ...c,
      ...L,
      duration: (Date.now() - ((n == null ? void 0 : n.duration) || 0)) / 1e3,
      visited: p,
      visitedPercentage: ((p == null ? void 0 : p.length) || 1) / ((n == null ? void 0 : n.totalSteps) || 0)
    }), r(void 0);
  }, g = (p) => {
    n && n.tourId === p.tourId && r({
      ...n,
      visited: [...(n == null ? void 0 : n.visited) || [], p.tourStep]
    });
  }, O = (p) => {
    const V = c ? { ...c, ...p } : p;
    t({ ...p, duration: Date.now() }), v("openContent", V);
  }, F = () => {
    if (o) {
      const p = Date.now() - ((o == null ? void 0 : o.duration) || 0);
      v("closeContent", {
        ...c,
        ...o,
        duration: p / 1e3
      }), t(void 0), c != null && c.duration && C({
        ...c
        //duration: currentScene?.duration + dur,
      }), n != null && n.duration && r({
        ...n
        //duration: currentTour?.duration + dur,
      }), I((V) => V + p);
    }
  }, v = (p, V) => {
    if (!(V != null && V.sceneId))
      return console.error("NO TRACKING PROPS FOR CURRENT DATA", p, V);
    const { type: L, action: W } = oo[p], b = {
      category: "experience",
      type: L,
      action: W,
      data: {
        sessionId: s,
        ...V
      }
    };
    Jt.trackEvent(b), a && (console.log(`%c  TRACKING${JSON.stringify(b, null, 2)}`, "background: #fff; color: #900"), console.log(`%c ['${b.category}', '${b.type}:${b.action}', '${JSON.stringify(b)}']`, "background: #fff; color: #900"));
  };
  return {
    startSession: k,
    enterScene: x,
    exitScene: d,
    openContent: O,
    closeContent: F,
    enterTour: _,
    exitTour: h,
    pushTourStep: g,
    debuggingEnabled: w,
    customSessionId: N
  };
}, Ro = rn(no, ro), ot = class ot {
  constructor() {
    he(this, "queue", []);
    he(this, "inited", !1);
    he(this, "debugEnabled", !1);
    he(this, "currentScene");
    he(this, "currentTour");
    if (ot._instance)
      return ot._instance;
    this.inited = !1, this.queue = [];
  }
  getQueue() {
    return this.queue;
  }
  addToQueue(t) {
    if (t.action === "startSession") {
      if (this.inited)
        return;
      this.inited = !0;
    }
    this.queue.push(t);
  }
  setDebugEnabled() {
    this.debugEnabled = !0;
  }
  getDebugEnabled() {
    return this.debugEnabled;
  }
  setCurrentScene(t) {
    this.currentScene = { ...t, duration: Date.now() };
  }
  getCurrentScene() {
    return this.currentScene;
  }
  setCurrentTour(t) {
    this.currentTour = t;
  }
  getCurrentTour() {
    return this.currentTour;
  }
  isInited() {
    return this.inited;
  }
};
he(ot, "_instance", new ot());
let Mt = ot;
const se = new Mt(), io = {
  debuggingEnabled: () => {
    se.setDebugEnabled();
  },
  startSession: (o) => {
    se.setCurrentScene(o), se.addToQueue({ action: "startSession", data: o });
  },
  enterScene: (o) => {
    se.setCurrentScene({ ...o, duration: Date.now() }), se.addToQueue({
      action: "enterScene",
      data: { ...o, duration: Date.now(), contentDuration: 0 }
    });
  },
  exitScene: () => {
  },
  enterTour: (o, t) => {
    const n = se.getCurrentScene();
    se.setCurrentTour({
      ...o,
      duration: Date.now(),
      visited: [o.tourStep],
      visitedPercentage: 0
    });
    const r = n != null && n.sceneId ? { ...n, ...o } : { ...t, ...o }, { totalSteps: s, ...i } = r;
    se.addToQueue({
      action: "enterTour",
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore // TODO
      data: i
    });
  },
  pushTourStep: () => {
  },
  exitTour: () => {
  },
  openContent: () => {
  },
  closeContent: () => {
  }
}, ao = () => {
  const o = "experience", [t, n] = A(), [r, s] = A(), [i] = A(ft()), [a, E] = A(se.getDebugEnabled()), [f, u] = A(se.isInited()), [c, C] = A(), [T, I] = A(0);
  M(() => {
    se.getQueue().forEach(({ action: v, data: p }) => {
      if (v == "enterScene") {
        const { duration: V, ...L } = p;
        F(v, L);
      } else
        F(v, p);
    }), se.getDebugEnabled() && E(!0), se.getCurrentScene() && C(se.getCurrentScene()), se.getCurrentTour() && s(se.getCurrentTour());
  }, []);
  const w = () => E(!0), N = (v) => {
    C(v), f || F("startSession", { ...v }), u(!0);
  }, k = (v) => {
    C({ ...v, duration: Date.now(), contentDuration: 0 }), I(0), F("enterScene", v);
  }, x = () => {
    if (c) {
      const v = {
        ...c,
        duration: (Date.now() - ((c == null ? void 0 : c.duration) || Date.now())) / 1e3,
        contentDuration: T / 1e3
      };
      F("exitScene", v);
    }
  }, d = (v, p) => {
    if ((r == null ? void 0 : r.tourId) === v.tourId)
      return;
    s({
      ...v,
      duration: Date.now(),
      visited: [v.tourStep],
      visitedPercentage: 0
    });
    const L = {
      ...c || p,
      ...v
    }, { totalSteps: W, ...b } = L;
    F("enterTour", b);
  }, _ = () => {
    if (!r)
      return console.warn(" NO CURENT TOUR FOR exitTour()");
    const v = [...new Set(r == null ? void 0 : r.visited)].sort((L, W) => L - W), { totalSteps: p, ...V } = r;
    F("exitTour", {
      ...c,
      ...V,
      duration: (Date.now() - ((r == null ? void 0 : r.duration) || 0)) / 1e3,
      visited: v,
      visitedPercentage: ((v == null ? void 0 : v.length) || 1) / ((r == null ? void 0 : r.totalSteps) || 0)
    }), s(void 0);
  }, h = (v) => {
    r && r.tourId === v.tourId && s({
      ...r,
      visited: [...(r == null ? void 0 : r.visited) || [], v.tourStep]
    });
  }, g = (v) => {
    const p = c ? { ...c, ...v } : v;
    n({ ...v, duration: Date.now() }), F("openContent", p);
  }, O = () => {
    if (t) {
      const v = Date.now() - ((t == null ? void 0 : t.duration) || 0);
      F("closeContent", {
        ...c,
        ...t,
        duration: v / 1e3
      }), n(void 0), c != null && c.duration && C({
        ...c
        //duration: currentScene?.duration + dur,
      }), r != null && r.duration && s({
        ...r
        //duration: currentTour?.duration + dur,
      }), I((p) => p + v);
    }
  }, F = (v, p) => {
    if (!(p != null && p.sceneId))
      return console.error("NO TRACKING PROPS FOR CURRENT DATA", v, p);
    Jt.customEvent([
      o,
      `${v}||${JSON.stringify({
        sessionId: i,
        ...p
      })}`
    ]), a && console.log(`%c  TRACKING ${v}||${JSON.stringify({
      sessionId: i,
      ...p
    }, null, 2)}`, "background: #fff; color: #900");
  };
  return {
    startSession: N,
    enterScene: k,
    exitScene: x,
    openContent: g,
    closeContent: O,
    enterTour: d,
    exitTour: _,
    pushTourStep: h,
    debuggingEnabled: w
  };
}, To = rn(io, ao);
export {
  Z as INavigationMenuItems,
  Co as SHOWROOM_TRACKING_PRE,
  _o as SHOWROOM_URL_PARAM,
  At as VideoActionType,
  Yt as VideoError,
  Oe as VideoEventType,
  Fn as VideoPlatform,
  wo as VideoPlatformContainer,
  ht as VideoPlatformContext,
  Eo as VideoPlatformContextProvider,
  de as VideoPlatformStateAction,
  Un as transformConfig,
  Ro as useShowroomTracking,
  To as useShowroomTrackingDeprecated,
  ao as useShowroomTrackingDeprecatedImpl,
  ro as useShowroomTrackingImpl
};
//# sourceMappingURL=index.es.js.map
